import { render } from "./TemplateApp.vue?vue&type=template&id=53756772"
import script from "./TemplateApp.vue?vue&type=script&lang=js"
export * from "./TemplateApp.vue?vue&type=script&lang=js"

import "./TemplateApp.vue?vue&type=style&index=0&id=53756772&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__